<template>
  <div>
    <Header />

    <PageContainer>
      <div class="gap-row-sm">
        <div class="iqos-grid">
          <div class="iqos-column">
            <ScoreBlock />
          </div>
          <div class="iqos-column">
            <StaticHint />
          </div>
        </div>
        <SystemsSurvey/>
        <SystemSetup v-for="mode in enabledModes" :key="mode" :mode="mode"/>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import StaticHint from "@/components/quickstart/StaticHint.vue";
import ScoreBlock from "@/components/quickstart/ScoreBlock.vue";
import SystemsSurvey from "@/components/quickstart/SystemsSurvey.vue";
import SystemSetup from "@/components/quickstart/SystemSetup.vue";

export default {
  components: {
    StaticHint,
    ScoreBlock,
    SystemsSurvey,
    SystemSetup,
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    enabledModes() {
      return Object.entries(this.cafe.modes).filter(e => e[1]).map(e => e[0]);
    }
  }
};
</script>